import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/i18n-vue";
import "./plugins/qrcode";
import "./plugins/vue-toast";
import App from "./App.vue";
import VueI18n from "vue-i18n";
import VueAgile from "vue-agile";
import common from "./utils/common";

Vue.config.productionTip = false;

Vue.prototype.$officialUrl = `https://javdb580.com`;
Vue.prototype.$pageUrl = "https://app.javdb580.com/";
Vue.prototype.$version = "1.9.35";
Vue.prototype.$iosVersion = "1.9.29";

Vue.prototype.$enabledIos = true;
Vue.prototype.$apkUrl = "https://ddbao.fssdag.com/jdb_official_v1.9.35.apk";
Vue.prototype.$iosSelfSignedUrl =
  "https://github.com/bdvajstudio/javdb/releases";
Vue.prototype.$iosTestFlightUrl = "https://apps.apple.com/cn/app/id899247664";
Vue.prototype.$iosAppStoreName = "有趣的黃梨";
Vue.prototype.$iosAppStoreUrl = "https://itunes.apple.com/app/id1544706402";
Vue.prototype.$iosAppStoreIconUrl =
  "https://is2-ssl.mzstatic.com/image/thumb/Purple124/v4/1e/aa/60/1eaa6055-4e69-bacc-eb7c-6e06799084d4/AppIcon-1x_U007emarketing-0-5-0-0-85-220.png/460x0w.png";
Vue.prototype.$iosAppStoreData =
  "FunnyYellowPear_smallKey:eyJpZCI6IjExMyIsImtleSI6InpwclVBRmFEZ1NHejlhVzgiLCJhcHBJZCI6ImphdmRiIiwicGxhdGZvcm0iOiJpb3MiLCJhSG9zdCI6Imh0dHBzOi8vYXpndy4zNjc5MDEuY29tIn0=";
Vue.prototype.$enabledIosAppStore = true;
Vue.prototype.$telegramChannel = `https://t.me/javdbnews`;
Vue.prototype.$channels = [
  "official",
  "appcenter",
  "javlib",
  "ac101",
  "ac102",
  "ac103",
  "ac104",
  "ac105",
];
Vue.prototype.common = common;

const messages = {
  en: {
    subtitle:
      "The most comprehensive App of Audlt movie resources, Watching online, Intelligent image recognition search, Find out which she/he in your mind",
    download: "Download",
    download_self_sign: "Self-Signed Version Download",
    goto_official_site: "Go to Official Website",
    telegram_channel: "Telegram Channel",
    platform_alert:
      "Currently the App only supports the Android platform and will be redirected to the official website soon",
    scan_qrcode: "Scan code to download",
    please_use_phone_install:
      "Please use your smart phone to scan the qrcode to install",
    android_qrcode_notice: `<p>Notice: </p>
    <p>1. Before downloading on Android phones, please go to "Settings> Security" and tick "Unknown Sources"</p>
    <p>2. Do not use WeChat's QRcode scanner`,
    ios_qrcode_notice: `<p>Notice: </p>
    <p>1. Download Apple's official test software "TestFlight" in the AppStore (if you have installed it, please skip to step 2)</p>
    <p>2. After completing step 1, click the button below to jump to the "TestFlight" client installation or update.</p>
    <p>💡 If it says "BETA version is full", please try again later, we will add new places in time.</p>`,
    downloading_title: "The download has started...",
    ios_warning:
      "The iOS version of the App has been banned too frequently recently and will temporarily switch to the Web version",
    web_version: "Web Version",
    ios_cert_repairing: "iOS repairing",
    testflight_step1:
      '1. Download Apple\'s official test software "TestFlight" in the AppStore (if you have installed it, please skip to step 2)',
    testflight_step2:
      '2. After completing step 1, click the button below to jump to the "TestFlight" client installation or update.',
    testflight_step3:
      '💡 If it says "BETA version is full", please try again later, we will add new places in time.',
    ios_installation: "iOS App Installation",
    follow_step_to_install: "Please follow the steps to install the app",
    qrcode_notice_for_desktop:
      'If you still see this interface in the mobile browser, please turn off the browser similar to "desktop browsing mode" or "computer mode", then refresh and try again.',
    app_store_light_version: "AppStore Light Version",
    appstore_installation_notice:
      'Please follow the steps below to install the light version:<br >1. Click "Copy Key"<br />2. Click "Get" to download the app and open it in the store<br >3. If you cannot enter the app, please return to this page Re "Copy key" and restart the app',
    copy_key: "Copy Key",
    copy_complete: "Copy complete",
    get: "Get",
    ios_disabled_message: `Due to the recent strict review by Apple, the native iOS version cannot be put on the Testflight. Please use the lightweight version or the web version temporarily.
    The Telegram announcement channel (<a href="https://t.me/javdbnews">@javdbnews</a>) provides the ipa package for users who can sign themselves.`,
    notice_message:
      "✅ The service has been restored, please delete the app to download the installation package and install it again.",
    fqa: "FQA",
    fqa_content: `
    <ul>
    <li>
    <strong>What should I do if I can’t install the APK?</strong>
    Open "Settings> Security" and check "Unknown Sources". There are differences in the system settings of different brands of mobile phones. You can set them by searching for the corresponding mobile phone brand and the keyword "install apk".
    </li>
    <li>
    <strong>What should I do if the installation of HarmonyOS is blocked?</strong>
    Open Settings > System and Update > Pure Mode to exit "Pure Mode"
    </li>
    <li>
    <strong>Why does it still show "initialization failed" after deleting the app and re-downloading the latest version and installing it?</strong>
    - Confirm that proxy software such as VPN has been turned off<br />
    - Open Settings -> Applications -> Find this APP -> Storage, click "Clear Data" and "Clear Cache" respectively<br />
    - Restart the app
    </li>
    </ul>
    `,
    github_download: "Github Download",
  },
  zh: {
    subtitle:
      "全網最全番號資料庫APP<br /> 在線觀看 / 磁鏈下載 / 優質評分排行 / TOP250 / 精彩影評 / 圖片智能識別",
    download: "下載安裝",
    download_self_sign: "自簽版本下載",
    goto_official_site: "或者去官網看看",
    telegram_channel: "Telegram公告频道",
    platform_alert: "目前App只支持Android平臺，即將跳轉到官方網站",
    scan_qrcode: "掃碼下載",
    please_use_phone_install: "請使用手機自帶相機掃碼安裝應用",
    android_qrcode_notice: `<p>安裝提醒: </p>
    <p>1. Android手機安装前請先至「設定 > 安全性」中將「未知的來源」勾選</p>
    <p>2. 鴻蒙手機安裝前請先至「設置 > 系統和更新 > 純淨模式」中退出「純淨模式」</p>
    <p>3. 請勿使用微信的QRcode掃碼器</p>`,
    ios_qrcode_notice: `<p>安裝提醒: </p>
    <p>1. 在AppStore下载苹果官方测试软件「TestFlight」(如果已安装的请直接跳到第2步)。</p>
    <p>2. 完成步骤1后，点击下方按钮，跳转到「TestFlight」客户端安装或更新應用即可。</p>
    <p>💡 如果提示「 BETA版已满额」請稍候再試，我們會及時增加新的名額。</p>`,
    downloading_title: "下載已開始...",
    ios_warning: "iOS版App近期封禁過於頻繁，將暫時轉向使用Web版",
    web_version: "網頁版(最新網址)",
    ios_cert_repairing: "iOS版本等待修復中...",
    testflight_step1:
      "1. 在AppStore下载苹果官方测试软件「TestFlight」(如果已安装的请直接跳到第2步)。",
    testflight_step2:
      "2. 完成步骤1后，点击下方按钮，跳转到「TestFlight」客户端安装或更新應用即可。",
    testflight_step3:
      "💡 如果提示「 BETA版已满额」請稍候再試，我們會及時增加新的名額。",
    ios_installation: "iOS 版安裝",
    follow_step_to_install: "請按照步驟安裝應用",
    qrcode_notice_for_desktop:
      "如果你在手機瀏覽器中依然看到此界面, <br />請關閉瀏覽器設置中類似「<strong>桌面瀏覽模式</strong>」或「<strong>電腦端模式</strong>」後，<br />再刷新重試",
    app_store_light_version: "AppStore輕量版",
    appstore_installation_notice:
      "<strong>請按照以下步驟安裝輕量版:</strong><br ><br >1. 點擊「複製密鑰」<br />2. 點擊「獲取」到商店下載應用並打開<br >3. 如果無法進入應用，請返回此頁面重新「複製密鑰」並重新重啟App",
    copy_key: "複製密鑰",
    copy_complete: "複製完成",
    get: "獲取",
    ios_disabled_message: `- 因Apple審核嚴格，iOS原生版無法上架，恢復時間未知，請暫時使用網頁版或者下載自簽版自行簽名使用。 <br />自簽版下載: <br />- <a href="https://github.com/bdvajstudio/javdb/releases">Github下載點</a><br />- <a href="https://t.me/javdbnews">Telegram公告頻道 @javdbnews</a>下載點`,
    notice_message: "✅ 服務已恢復，請刪除app重新下載安裝包並安裝。",
    fqa: "常見問題",
    fqa_content: `
    <ul>
    <li>
    <strong>無法安裝APK怎麼辦?</strong>
    打開 「設定 > 安全性」中將「未知的來源」勾選，不同品牌手機系統設置有區別，可通過搜索對應手機品牌和關鍵字「安裝apk」進行設置。
    </li>
    <li>
    <strong>鴻蒙手機安裝被阻止怎麼辦?</strong>
    打開「設置 > 系統和更新 > 純淨模式」中退出「純淨模式」
    </li>
    <li>
    <strong>為什麼刪除App重新下載最新版安裝依然顯示「初始化失敗」?</strong>
    - 確認已關閉VPN等代理軟件<br />
    - 打開 設置 -> 應用程序 -> 找到本APP -> 存儲, 分別點擊「清除數據」和「清除緩存」<br />
    - 重啟app
    </li>
    </ul>
    `,
    github_download: "Github下载",
  },
};

const i18n = new VueI18n({
  locale: "zh",
  messages,
});

Vue.use(VueAgile);
new Vue({
  render: (h) => h(App),
  i18n,
}).$mount("#app");
